import { IconStyled, IconStylesProps } from './IconStyles';

export const ArrowDown = ({
  size = 'base',
  className = '',
  fill = 'currentColor',
  transform,
  onClick,
}: Partial<IconStylesProps>) => (
  <IconStyled
    onClick={onClick}
    size={size}
    className={className}
    viewBox='0 0 9 6'
    fill={fill}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      style={{
        transform,
        transformOrigin: '50% 50%',
      }}
      d='M4.02454 5.6141L0.198343 1.7879C-0.0661144 1.52344 -0.0661144 1.09581 0.198343 0.834167L0.834167 0.198343C1.09862 -0.0661144 1.52626 -0.0661144 1.7879 0.198343L4.5 2.91044L7.2121 0.198343C7.47655 -0.0661144 7.90419 -0.0661144 8.16583 0.198343L8.80166 0.834167C9.06611 1.09862 9.06611 1.52626 8.80166 1.7879L4.97546 5.6141C4.71663 5.87856 4.289 5.87856 4.02454 5.6141Z'
      fill={fill}
    />
  </IconStyled>
);
